









import VueOptions from '@utils/VueOptions'
import AlertBar from '@components/AlertBar'

settings =
  vue:
    name: 'EventAlertBar'
    props: ['event']
    components: { AlertBar }
    methods: 
      alert: () ->
        return @promptToPublishAlert() if @event.draft
        return @promptToConfirmAlert() if @event.potential_unconfirmed
        return @promptToAcceptOfferAlert() if @ctxStats(@event)?.offer?.pending_count > 0
        # return @promptToTransferAlert() 
        return null
      promptToAcceptOfferAlert: ->
        {
          id: @event.id
          type: 'cta'
          message: "You've received a new sponsorship offer!"
          button: { label: 'View Offers', nav: { params: { tab: 'offers' } } } 
          dismissable: false
        }
      promptToConfirmAlert: ->
        {
          id: @event.id
          type: 'info'
          message: "We created #{@event.name}'s next event. Please double-check that the info is correct and confirm it."
          button: null 
          dismissable: false
        }
      promptToPublishAlert: ->
        action = "Publish #{@event.name} today!"
        if @event.missing_required_fields.length > 0
          action = "Complete #{@event.missing_required_fields.length} fields to publish #{@event.name} today!"
        {
          id: @event.id
          type: 'info'
          message: "Event sponsors are waiting - #{action}"
          button: null
          dismissable: false
        }
      promptToTransferAlert: ->
        {
          id: @event.id
          type: 'cta'
          message: ''
          button: { label: 'Transfer Event', action: => console.log 'transferred' }
          dismissable: false
        }

export default VueOptions.vue settings
